/* globals hj */

const { hotjarInit } = require('./hotjar-init')

// ? ******************************************************************************************
// ? ******************************************************************************************

/**
 * @param {string} event
 */
function hotjarTriggerEvent (event) {
  if (typeof window === 'undefined') return

  hotjarInit()
  hj('trigger', event)
}

module.exports = { hotjarTriggerEvent }
